<div class="dropdown-container">
  <div class="dropdown-button" (click)="toggleDropdown()">
    {{ (selectedCard?.maskedCardNumber ?? selectedCard?.value) || 'SELECT' }}
    <span class="arrow-down" *ngIf="!dropdownOpen"></span>
    <span class="arrow-up" *ngIf="dropdownOpen"></span>
  </div>
  <div class="dropdown-cards" *ngIf="dropdownOpen">
    <div
      class="dropdown-card"
      *ngFor="let card of cards"
      (click)="selectCard(card, $event)"
    >
      <span class="dropdown-card-content">{{
        card?.maskedCardNumber ?? card?.value
      }}</span>
      <span
        class="delete-icon"
        *ngIf="showDeleteIcon && card?.maskedCardNumber"
        (click)="confirmRemoveCard(card, $event)"
        >×</span
      >
    </div>
  </div>
</div>

<!-- To prevent a seperate component implementation of delete confirmation dialog box: -->
<ng-template #deleteDialogBox let-modal>
  <div class="delete-modal-header">
    <h5 class="delete-modal-title">Confirm Deletion</h5>
  </div>
  <div class="modal-body delete-modal-body">
    <p>
      Are you sure you want to delete this card:
      {{ cardToDelete?.maskedCardNumber }} ?
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="delete-modal-buttons"
      (click)="modal.dismiss('cancel')"
    >
      Cancel
    </button>
    <button type="button" class="delete-modal-buttons" (click)="removeCard()">
      Delete
    </button>
  </div>
</ng-template>
